import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {GetComparatorAdsService} from '../Services/GetComparatorAdsService.js'

class GetComparatorAdsUseCase extends UseCase {
  #service

  #handleError(error) {
    return Promise.reject(
      DomainSharedError.isDomainError({error}) ? error : DomainSharedError.createGenericError({cause: error})
    )
  }

  constructor({service}) {
    super()
    this.#service = service
  }

  static create() {
    return new GetComparatorAdsUseCase({service: GetComparatorAdsService.create()})
  }

  @tracer({metric: 'GetComparatorAdsUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    try {
      const [error, response] = await this.#service.execute()
      return error ? this.#handleError(error) : response
    } catch (error) {
      return this.#handleError(error)
    }
  }
}

export const factory = GetComparatorAdsUseCase.create
